import type { HttpClient } from '@shared/http/http-client';
import type {
  IPatientRepository,
  PatientListQuery,
} from '@domain/data-contracts/patient-repository.interface';
import type { Patient } from '@domain/models/patient.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapPatientDto,
  mapPaged,
  type PatientDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/patients';

export class PatientRepository implements IPatientRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: PatientListQuery): Promise<PagedResult<Patient>> {
    const response = await this.http.get<PagedDto<PatientDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapPatientDto);
  }
}

function pruneParams(query: PatientListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (query.clientId) { out.clientId = query.clientId; }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
